<template>
		<div class="footer_wrap">
            <div class="footer">
                    <div class="information">
                        <p>公司名称：海南搜易科技有限公司</p>
                        <p>地址：海南省省直辖县级行政单位澄迈县老城高新技术产业示范区海南生态软件园A09-101</p>
                        <p>备案号：<a href="https://beian.miit.gov.cn/">琼ICP备18000133号-2</a></p>
                        <p>举报链接：<a href="http://jb.ccm.gov.cn/12318/">http://jb.ccm.gov.cn/12318/</a></p>
                    </div>
                    <div class="clear"></div>

            </div>

        </div>

</template>
<script>
export default {
  data () {
    return{
        footer:{
           text:'©MoreFun Technology Limited . Trademarks belong to their respective owners. All rights reserved'
        }
    }
  },
  mounted:function(){

  },
  methods:{

  }
}
</script>
<style scoped>
    .footer_wrap{
        width: 100%;
        height: 240px;
        background: url(../../static/img/footer.jpg) no-repeat;
        background-size: 100% 100%
    }
    .footer{
        width: 1200px;
        margin: 0 auto;
        height: 240px;
        text-align: center;
    }
    .footer .logoIc{
        margin-top: 60px
    }
    .footer .footer_p{
        font-size: 12px;
        color: #999;
        margin-top: 40px;
        float: left;
    }
    .f-logo{
        font-size: 28px;
        color: #ff5f31;
        margin-top: 120px;
        margin-right: 10%;
        float: left;
    }
    .information{
        margin-top: 50px;
        width: 70%;
        float: left;
        text-align: left;
        color: white;
        font-size: 14px;
        margin-left: 5%
    }
    .information p{
        margin:5px
    }
    .information p a{
        text-decoration: none;
        color: white
    }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue